import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  mainContainer: {
    display: "inline-block"
  }
}))